import * as React from 'react';
const { useState } = React;
import { IonContent, IonPage, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCardContent, IonItem, IonLabel, IonHeader, IonToolbar, IonMenuButton, IonTitle, IonButtons, IonInput, IonButton, IonSelect, IonSelectOption, IonIcon, useIonAlert } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Formik } from 'formik';
import { Fingerprint311Schema } from '../data/validations';
import { star, returnDownBack } from 'ionicons/icons';
import { GetBirthPlaces, GetRaces, GetEyeColors, GetHairColors, WriteXMLFile, IsSlotAvailable, AddApptRecord, SendEmail } from '../data/api';
import { GetFingerprintEmailBody } from '../data/MyRoutines';
import { useHistory } from "react-router-dom";
import { useQuery } from '@tanstack/react-query';
import './Fingerprint311Apt.css';
interface StateProps {
  title: string
}


interface RouteProps extends RouteComponentProps<{ keyValue: string }> { }
interface GenericProps extends RouteProps, StateProps { }

const Fingerprint311Apt: React.FC<GenericProps> = ({ match, title }) => {

  const [present] = useIonAlert();

  var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

  // Blank=B /=S :=C
  const key = (match.params.keyValue.replaceAll("B", " ").replaceAll("S", "/").replaceAll("C", ":"));

  
  const valDate = key.substring(0, 10).toString().trim();
  const valStart = key.substring(10, 22).trim();
  const valEnd = key.substring(23, 35).trim();
  
  const [typeMode, setTypeMode] = useState(false);
  const myPlaces = useQuery({ queryKey: ["GetBirthPlaces311"], queryFn: () => GetBirthPlaces() });
  const myRaces = useQuery({ queryKey: ["GetRaces311"], queryFn: () => GetRaces() });
  const myEyes = useQuery({ queryKey: ["GetEyeColor311"], queryFn: () => GetEyeColors() });
  const myHairs = useQuery({ queryKey: ["GetHairColor311"], queryFn: () => GetHairColors() });


  const [selectedDate, setselectedDate] = useState(new Date(valDate));


  const history = useHistory()
  const goBack = () => {
    history.goBack()
  }




  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Fingerprint New Appointment </IonTitle>
          <IonIcon slot="end" icon={returnDownBack} size="large" className="ion-padding-end" onClick={goBack} />
        </IonToolbar>
      </IonHeader>
      <IonContent color="light">
        

        <IonCard>
          <IonCardHeader>
            <IonCardSubtitle>Selected Date/Time</IonCardSubtitle>
            <IonCardTitle color="danger">
              &nbsp;&nbsp;
              <IonIcon icon={star} size="large" color="danger" />
              &nbsp;&nbsp; <u>{new Date(valDate).toLocaleDateString("en-US")} {valStart} - {valEnd}</u>
            </IonCardTitle>
          </IonCardHeader>

          <IonCardContent>
            <Formik
              initialValues={{
                lastname: "",
                firstname: "",
                middlename: "",
                email: "",
                dateofbirth: "",
                birthplace: "UT",
                race: "",
                gender: "",
                eye: "",
                hair: "",
                height: "",
                weight: ""
              }}


              validationSchema={Fingerprint311Schema}
              onSubmit={async values => {
                await new Promise(resolve => setTimeout(resolve, 200));

                // double check availability
                let avail = true;
                let startDate = valDate + ' ' + valStart;
                let endDate = valDate + ' ' + valEnd;

                const data = await IsSlotAvailable(startDate, endDate, 'F');
                if (data != true) {
                  avail = false;
                  present('Sorry that someone has just made an appointment on the time you selected. Plese select a different time period for your appointment!', [{ text: 'Ok' }])
                }



                if (avail) {
                  // Save Record
                  const data = await AddApptRecord(startDate, endDate, 'F', values.email, values.firstname.trim()+' '+values.lastname.trim() , 'A');
                  // Sending Email (fire-and-forget so we don't block UI)
                  let myContent = GetFingerprintEmailBody(values.firstname.trim() + ' ' + values.lastname.trim(), valDate, valStart, valEnd, values.email, data);
                  SendEmail('noreply@orem.gov', values.email, 'City of Orem - 311 Employment Fingerprint Appointment Confirmation', myContent);
                  SendEmail('noreply@orem.gov', 'utilities@orem.gov', 'City of Orem - 311 Employment Fingerprint Appointment Confirmation (Copy) (' + values.firstname.trim()+ values.lastname.trim() + ')', myContent);

                  // Show success and navigate immediately so the user always gets feedback
                  present('Your appointment has been successfully made. Please check your email for confirmation information.', [{ text: 'Ok' }]);
                  history.push('/tabs/Fingerprint311');

                  // Write the import file in the background (do not block; avoid hang and "nothing happens")
                  WriteXMLFile(
                    values.lastname,
                    values.firstname,
                    values.middlename,
                    values.email,
                    values.dateofbirth,
                    values.birthplace,
                    values.race,
                    values.gender,
                    values.eye,
                    values.hair,
                    values.height,
                    values.weight
                  ).catch(() => {
                    // Optional: could show a toast here; appointment is already saved
                  });
                }

                }

              }
            >
              {(formikProps: any) => (
                <form
                  onSubmit={formikProps.handleSubmit}
                  style={{ paddingBottom: "40px" }}
                >
                  <IonItem>
                    <IonLabel>First Name:</IonLabel>
                    <IonInput
                      type="text"
                      name="firstname"
                      required={true}
                      onIonChange={formikProps.handleChange}
                      value={formikProps.values.firstname}
                    />
                    {formikProps.errors.firstname != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.firstname && formikProps.errors.firstname
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>
                  
                  <IonItem>
                    <IonLabel>Middle Name:</IonLabel>
                    <IonInput
                      type="text"
                      name="middlename"
                      onIonChange={formikProps.handleChange}
                      value={formikProps.values.middlename}
                    />
                    {formikProps.errors.middlename != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.middlename && formikProps.errors.middlename
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Last Name:</IonLabel>
                    <IonInput
                      type="text"
                      name="lastname"
                      required={true}
                      onIonChange={formikProps.handleChange}
                      value={formikProps.values.lastname}
                    />
                    {formikProps.errors.lastname != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.lastname && formikProps.errors.lastname
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Email:</IonLabel>
                    <IonInput
                      type="text"
                      name="email"
                      onIonChange={async (e: any) => {
                        //check next slot available
                        formikProps.values.email = e.detail.value.toLowerCase();
                        formikProps.handleChange(e);
                      }}
                      value={formikProps.values.email}
                      required={true}

                    />
                    {formikProps.errors.email != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.email && formikProps.errors.email
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>


                  <IonItem>
                    <IonLabel>Date Of Birth:</IonLabel>
                    <IonInput
                      type="text"
                      name="dateofbirth"
                      onIonChange={formikProps.handleChange}
                      value={formikProps.values.dateofbirth}
                      required={true}
                      placeholder="YYYYMMDD"
                    />
                    {formikProps.errors.dateofbirth != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.dateofbirth && formikProps.errors.dateofbirth
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Place of Birth</IonLabel>
                    <IonSelect 
                      name="birthplace"
                      value={formikProps.values.birthplace}
                      placeholder="Select One"
                      onIonChange={formikProps.handleChange}
                     
                      >
                      {myPlaces.isSuccess && myPlaces.data.map((myplace: any, index: number) => (
                            <IonSelectOption value={myplace.code} key={`birthplace-${myplace.code}-${index}`}>{myplace.description}</IonSelectOption>
                            ))
                       }
                       
                    </IonSelect>
                    {formikProps.errors.birthplace != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.birthplace && formikProps.errors.birthplace
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Race</IonLabel>
                    <IonSelect
                      name="race"
                      value={formikProps.values.race}
                      placeholder="Select One"
                      onIonChange={formikProps.handleChange}
                    >

                      {myRaces.isSuccess && myRaces.data.map((myRace: any, index: number) => (
                          <IonSelectOption value={myRace.code} key={`race-${myRace.code}-${index}`}>{myRace.description}</IonSelectOption>
                      ))
                      }

                    </IonSelect>
                    {formikProps.errors.race != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.race && formikProps.errors.race
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>
                  

                  <IonItem>
                    <IonLabel>Gender</IonLabel>
                    <IonSelect
                      name="gender"
                      value={formikProps.values.gender}
                      placeholder="Select One"
                      onIonChange={formikProps.handleChange}
                    >
                      <IonSelectOption value="M">Male</IonSelectOption>
                      <IonSelectOption value="F">Female</IonSelectOption>
                      <IonSelectOption value="X">Unknown</IonSelectOption>
                    </IonSelect>
                    {formikProps.errors.gender != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.gender && formikProps.errors.gender
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Eye Color</IonLabel>
                    <IonSelect
                      name="eye"
                      value={formikProps.values.eye}
                      placeholder="Select One"
                      onIonChange={formikProps.handleChange}
                    >

                      {myEyes.isSuccess && myEyes.data.map((myEye: any, index: number) => (
                          <IonSelectOption value={myEye.code} key={`eye-${myEye.code}-${index}`}>{myEye.description}</IonSelectOption>
                      ))
                      }

                    </IonSelect>
                    {formikProps.errors.eye != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.eye && formikProps.errors.eye
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>


                  <IonItem>
                    <IonLabel>Hair Color</IonLabel>
                    <IonSelect
                      name="hair"
                      value={formikProps.values.hair}
                      placeholder="Select One"
                      onIonChange={formikProps.handleChange}
                    >

                      {myHairs.isSuccess && myHairs.data.map((myHair: any, index: number) => (
                          <IonSelectOption value={myHair.code} key={`hair-${myHair.code}-${index}`}>{myHair.description}</IonSelectOption>
                      ))
                      }

                    </IonSelect>
                    {formikProps.errors.hair != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.hair && formikProps.errors.hair
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Height:</IonLabel>
                    <IonInput
                      type="text"
                      name="height"
                      min="0"
                      onIonChange={formikProps.handleChange}
                      value={formikProps.values.height}
                      required={true}
                      placeholder="(e.g. 5'8 = 508)"
                    />
                    {formikProps.errors.height != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.height && formikProps.errors.height
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  <IonItem>
                    <IonLabel>Weight:</IonLabel>
                    <IonInput
                      type="text"
                      name="weight"
                      min="0"
                      onIonChange={formikProps.handleChange}
                      value={formikProps.values.weight}
                      required={true}
                     
                    />
                    {formikProps.errors.weight != null && (
                      <IonItem>
                        <IonLabel color="danger" className="ion-padding">
                          {formikProps.touched.weight && formikProps.errors.weight
                          }</IonLabel>
                      </IonItem>
                    )
                    }
                  </IonItem>

                  

                  <IonButton
                    color="primary"
                    expand="block"
                    type="submit"
                  >Submit</IonButton>
                </form>
              )}

            </Formik>

          </IonCardContent>
        </IonCard>

      </IonContent>
    </IonPage>
  )
}

export default Fingerprint311Apt;
